// src/encounter/add-entry.tsx
//
// The ONE "add" entry of the note (19 Oct, Antonin: "Add note inlines exactly like the prototype's dashed Add clinical phrase";
// "make the add pattern one consistent pattern everywhere it appears in the note"). The prototype's `+ Insert clinical phrase`
// (`scrips-clinician-demo` `src/views/soh/encounter/PhraseNote.tsx`): a 32 px control, a dashed hairline, a plus and the label
// in the label role, secondary ink, the border and ink darken on hover. Look in `src/styles/showcase-bridge.css`
// (`/* soap page */`, hook `data-add-entry`); same DS Button, same handlers, same names.
import type { ComponentProps } from 'react';
import { Button } from '@scripsteam/scrips-signal-ds';
import { Plus } from 'lucide-react';

export function AddEntryButton(props: Omit<ComponentProps<typeof Button>, 'variant' | 'size' | 'icon'>) {
  return <Button variant="tertiary" size="sm" data-add-entry="" icon={<Plus className="size-4" aria-hidden />} {...props} />;
}
